export class StringUtils
{
	public static capitalize(value: string = "")
	{
		return value.charAt(0).toUpperCase() + value.slice(1);
	}

	public static capitalizeEachWordInSentence(value: string = ""): string
	{
		const array = value.split(" ");

		return array.map((word: string) => StringUtils.capitalize(word)).join(" ");
	}
}